export default __webpack_public_path__ + "static/media/timeline_3.e6b6f1de.svg";